import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../assets/images/Instagram_logo@2x.png'
import _imports_1 from '../../assets/images/Facebook_logo@2x.png'
import _imports_2 from '../../assets/images/TikTok_logo@2x.png'
import _imports_3 from '../../assets/images/Twitter_logo@2x.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "stats-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_0
  })
], -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_13 = {
  key: 1,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_1
  })
], -1)
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_23 = {
  key: 2,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_2
  })
], -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_33 = {
  key: 3,
  class: "d-flex flex-justify-center flex-items-center my-3"
}
const _hoisted_34 = ["href"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "stats-img",
    src: _imports_3
  })
], -1)
const _hoisted_39 = ["href"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_43 = {
  key: 4,
  class: "stats-total mb-5"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h6", { class: "subtitle" }, "Total score", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "dots-horizontal" }, null, -1)
const _hoisted_46 = { class: "d-flex flex-justify-center" }
const _hoisted_47 = { class: "stats-value" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)
const _hoisted_49 = { class: "stats-value level-bg" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h6", null, "obserwujących", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.compare1 && _ctx.compare2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare1.instagramUrl,
              target: "_blank"
            }, [
              (_ctx.compare1.instagramFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.formatNumber(_ctx.compare1.instagramFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare1.instagramFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_6, "-"))
                : _createCommentVNode("", true),
              _hoisted_7
            ], 8, _hoisted_4),
            _hoisted_8,
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare2.instagramUrl,
              target: "_blank"
            }, [
              (_ctx.compare2.instagramFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_10, _toDisplayString(_ctx.formatNumber(_ctx.compare2.instagramFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare2.instagramFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_11, "-"))
                : _createCommentVNode("", true),
              _hoisted_12
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      (_ctx.compare1 && _ctx.compare2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare1.facebookUrl,
              target: "_blank"
            }, [
              (_ctx.compare1.facebookFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_15, _toDisplayString(_ctx.formatNumber(_ctx.compare1.facebookFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare1.facebookFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_16, "-"))
                : _createCommentVNode("", true),
              _hoisted_17
            ], 8, _hoisted_14),
            _hoisted_18,
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare2.facebookUrl,
              target: "_blank"
            }, [
              (_ctx.compare2.facebookFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_20, _toDisplayString(_ctx.formatNumber(_ctx.compare2.facebookFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare2.facebookFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_21, "-"))
                : _createCommentVNode("", true),
              _hoisted_22
            ], 8, _hoisted_19)
          ]))
        : _createCommentVNode("", true),
      (_ctx.compare1 && _ctx.compare2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare1.tiktokUrl,
              target: "_blank"
            }, [
              (_ctx.compare1.tiktokFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_25, _toDisplayString(_ctx.formatNumber(_ctx.compare1.tiktokFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare1.tiktokFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_26, "-"))
                : _createCommentVNode("", true),
              _hoisted_27
            ], 8, _hoisted_24),
            _hoisted_28,
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare2.tiktokUrl,
              target: "_blank"
            }, [
              (_ctx.compare2.tiktokFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_30, _toDisplayString(_ctx.formatNumber(_ctx.compare2.tiktokFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare2.tiktokFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_31, "-"))
                : _createCommentVNode("", true),
              _hoisted_32
            ], 8, _hoisted_29)
          ]))
        : _createCommentVNode("", true),
      (_ctx.compare1 && _ctx.compare2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare1.twitterUrl,
              target: "_blank"
            }, [
              (_ctx.compare1.twitterFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_35, _toDisplayString(_ctx.formatNumber(_ctx.compare1.twitterFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare1.twitterFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_36, "-"))
                : _createCommentVNode("", true),
              _hoisted_37
            ], 8, _hoisted_34),
            _hoisted_38,
            _createElementVNode("a", {
              class: "stats-value",
              href: _ctx.compare2.twitterUrl,
              target: "_blank"
            }, [
              (_ctx.compare2.twitterFanCount>0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_40, _toDisplayString(_ctx.formatNumber(_ctx.compare2.twitterFanCount)), 1))
                : _createCommentVNode("", true),
              (_ctx.compare2.twitterFanCount===0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_41, "-"))
                : _createCommentVNode("", true),
              _hoisted_42
            ], 8, _hoisted_39)
          ]))
        : _createCommentVNode("", true),
      (_ctx.compare1 && _ctx.compare2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _hoisted_44,
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.formatNumber(_ctx.compare1.instagramFanCount + _ctx.compare1.facebookFanCount + _ctx.compare1.twitterFanCount + _ctx.compare1.tiktokFanCount)), 1),
                _hoisted_48
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.formatNumber(_ctx.compare2.instagramFanCount + _ctx.compare2.facebookFanCount + _ctx.compare2.twitterFanCount + _ctx.compare2.tiktokFanCount)), 1),
                _hoisted_50
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}